export const PERMISSION_ERROR = 'You have no permissions for this activity';
export const SERVER_ERROR = "Sorry, we've got a server error, please try a bit later";
export const FILE_ERROR =
  'Sorry, we can not process your file. Please check its size/format';
export const SIZE_ERROR = 'To access more areas, please contact the administrator';
export const DEFAULT_ERROR = 'Something went wrong';
export const NOT_POLYGON = 'Please add file with type "Polygon"';
export const NOT_FOUND = 'Not found';
